<template lang='pug'>
i.svg-icon.svg-icon-locker
  svg(
    :fill='color'
    :width='`${size}px`'
    :height='`${size}px`'
    viewBox='0 0 100 100')

    path(d='M28.56,37.72c0-3.25-0.06-6.45,0.03-9.64c0.05-1.7,0.2-3.43,0.57-5.09c1.99-8.92,10.21-15.5,19.33-15.71 c4.42-0.1,8.67,0.45,12.5,2.81c6.52,4.01,9.92,9.88,10.13,17.54c0.08,3.01,0.01,6.03,0.01,9.05c0,0.34,0,0.68,0,1.05 c3.07,0.16,5.53,1.34,7.33,3.76c1.15,1.54,1.77,3.3,1.78,5.22c0.02,9.71,0.09,19.43-0.02,29.14c-0.11,8.98-7.75,16.62-16.71,16.73 c-9.12,0.11-18.25,0.11-27.37,0c-9.03-0.12-16.62-7.86-16.69-16.95c-0.07-9.59-0.04-19.17-0.01-28.76 C19.47,41.86,23.1,38.21,28.56,37.72z M49.83,43.85c-6.94,0-13.88,0-20.81,0c-2.33,0-3.49,1.17-3.49,3.52c0,9.2-0.01,18.41,0,27.61 c0.01,6.56,4.93,11.51,11.47,11.52c8.55,0.01,17.11,0.01,25.66,0c6.61-0.01,11.52-4.94,11.53-11.56c0.01-9.17,0-18.35,0-27.52 c0-2.4-1.16-3.57-3.54-3.58C63.7,43.85,56.76,43.85,49.83,43.85z M65.05,37.72c0-3.43,0.09-6.79-0.02-10.15 c-0.18-5.71-2.85-9.94-7.87-12.65c-2.84-1.53-5.93-1.67-9.06-1.52c-6.66,0.32-12.53,5.6-13.25,12.24c-0.35,3.2-0.16,6.46-0.21,9.69 c-0.01,0.78,0,1.57,0,2.38C44.81,37.72,54.86,37.72,65.05,37.72z')

    path(d='M46.81,69.62c0-1.46-0.03-2.92,0.01-4.38c0.02-0.63-0.19-1.01-0.69-1.41c-2.84-2.21-3.17-6.3-0.75-8.92 c2.38-2.58,6.48-2.6,8.89-0.05c2.44,2.59,2.17,6.75-0.66,8.92c-0.59,0.45-0.74,0.9-0.73,1.58c0.03,2.89,0.02,5.77,0.01,8.66 c-0.01,1.95-1.25,3.32-3.01,3.34c-1.79,0.02-3.06-1.37-3.07-3.37C46.8,72.54,46.81,71.08,46.81,69.62z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>